import mod from "-!./dyKeyboard.js?vue&type=script&lang=js&"; export default mod; export * from "-!./dyKeyboard.js?vue&type=script&lang=js&"